import gql from 'graphql-tag';

const GET_SERVICES = gql`
  {
    services {
      id
      name
      price
      duration
      split
      category
    }
  }
`

export default GET_SERVICES;